export const DEFAULT_TITLE = 'Your Picks';
export const DEFAULT_SHAREBYEMAIL = 'SHARE BY EMAIL';
export const DEFAULT_CONFIGURE_SUBTITLE = 'As configured';
